import Swal from "sweetalert2";

const SwalError = (text:string)=>{
    SwalClose()
    Swal.fire({
        text:text,
        icon:"error",
        confirmButtonText : 'تایید',
        title : 'خطا'

    })
}
const SwalSuccess = (text:string)=>{
    SwalClose()
    Swal.fire({
        text:text,
        icon:"success",
        confirmButtonText : 'تایید',
        title : 'موفقیت'

    })
}
const SwalLoading = ()=>{
    Swal.fire({
        text:'در حال بارگزاری',
        showConfirmButton:false,
        allowOutsideClick : false
    })
}
const SwalConferm = (message : string)=>{
  return   Swal.fire({
        title : 'اخطار',
        icon : "warning",
        showConfirmButton : true,
        text : message,
        confirmButtonText : 'تایید',
        cancelButtonText :'لغو',

    })
}
const SwalClose = ()=>Swal.close()
export {SwalError,SwalLoading,SwalClose,SwalConferm,SwalSuccess}